import { render } from "./Shotlist.vue?vue&type=template&id=82bd7530"
import script from "./Shotlist.vue?vue&type=script&lang=js"
export * from "./Shotlist.vue?vue&type=script&lang=js"
script.render = render

export default script